import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets the list of account types.
 */
export const getAccountTypes = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/tipoCuentas`)
)

/**
 * Gets the list of national banks available.
 */
export const getBanks = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/institucionesBancarias`)
)

/**
 * Gets the list of areas that matched the query.
 */
export const getBusinessAreas = factoryService(({ query }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/categoria/${query}`)
)

/**
 * Gets the list of income brackets.
 */
export const getBusinessIncomeBrackets = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/usuario-temporal/tramo-empresa`)
)

/**
 * Gets the list of business sizes.
 */
export const getBusinessSizes = factoryService(() => getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/proveedor/tamano`))

/**
 * Gets the list of states of the country.
 */
export const getStates = factoryService(() => getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/geografia/region`))

/**
 * Gets the list of districts of a state.
 */
export const getDistricts = factoryService(({ stateID }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/geografia/region/${stateID}/comuna`)
)

/**
 * Gets the list of countries.
 */
export const getCountries = factoryService(({ order }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/geografia/pais?orden=${order}`)
)
